export const MAX_CAPACITY_FOR_TOUR = 50;
export const ALL_ACCESS_PROMO_COUNTRY_ALLOWLIST = ['US', 'CA'];
export const DRIFT_DETAILS = {
  Product_Interests: 'Workspace',
  Lead_Source: 'WeWork.com',
  Lead_Source_Subtype_: 'Chat',
  Lead_Source_Detail_: '',
  Create_Source: 'WeWork.com'
};
